import { XIcon } from 'lucide-react';
import { useTabManager } from '../../tab-manager';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';
import { useCallback } from 'react';

export const CloseTabButton: React.FC<{
  tabId: string;
  className?: string;
  onClose?: (tabId: string) => boolean;
}> = ({ tabId, className, onClose }) => {
  const { close } = useTabManager();

  const handleClose = useCallback(() => {
    const next = onClose?.(tabId) ?? true;
    if (next === true) {
      close(tabId);
    }
  }, [close, tabId, onClose]);

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn(
        'size-6 opacity-0 group-hover:opacity-100 transition-opacity',
        className
      )}
      onClick={(e) => {
        e.stopPropagation();
        handleClose();
      }}
    >
      <XIcon className="text-muted-foreground" />
    </Button>
  );
};
